module.exports = {
  timeout: 15 * 60 * 1000 // 15 minutes
}
